import { render, staticRenderFns } from "./OrbitClaimModal.vue?vue&type=template&id=5fb2d2b6"
import script from "./OrbitClaimModal.vue?vue&type=script&lang=ts"
export * from "./OrbitClaimModal.vue?vue&type=script&lang=ts"
import style0 from "./OrbitClaimModal.vue?vue&type=style&index=0&id=5fb2d2b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports